export default "__VITE_ASSET__DwxtaiTP__"